import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const QueryField = ({ querySelectOptions, disabled }) => {
  return (
    <Field name="query" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Query</label>
          <Select {...input} multi options={querySelectOptions} className="form-select" disabled={disabled} />
        </Fragment>
      )}
    </Field>
  );
};

QueryField.propTypes = {
  querySelectOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

QueryField.defaultProps = {
  disabled: false,
};

export default QueryField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/QueryField.jsx